export default __webpack_public_path__ + "static/media/tailwind-icon.78c92cee.svg";